<template>
  <k-page class="page-stats-main">
    <the-stats-main />
  </k-page>
</template>

<script>
/**
 * Component: page-stats-main - Страница общей статистики
*
* @version 1.0.0
*/


// Components
import KPage from '@/components/KPage.vue';
import TheStatsMain from '@/components/TheStatsMain.vue';


export default {
  name: 'page-stats-main',

  components: {
    KPage,
    TheStatsMain,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-stats-main {
  $this: &;
}
</style>
